import { useState, useEffect, useCallback } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { MarketingLayout } from "../components/MarketingLayout";
import { Badge } from "../components/ui/badge";
import { Search, Clock, ArrowRight, ChevronLeft, ChevronRight, BookOpen } from "lucide-react";
import axios from "axios";

var API = process.env.REACT_APP_BACKEND_URL;

export const ArticlesPage = () => {
  var [sp, setSp] = useSearchParams();
  var [articles, setArticles] = useState([]);
  var [loading, setLoading] = useState(true);
  var [total, setTotal] = useState(0);
  var [pages, setPages] = useState(1);
  var [categories, setCategories] = useState([]);
  var [search, setSearch] = useState(sp.get("search") || "");
  var [cat, setCat] = useState(sp.get("category") || "");
  var page = parseInt(sp.get("page") || "1");

  var fetch = useCallback(function() {
    setLoading(true);
    var p = { page: page, limit: 12 }; if (cat) p.category = cat; if (search) p.search = search;
    axios.get(API + "/api/articles", { params: p }).then(function(r) { setArticles(r.data.articles); setTotal(r.data.total); setPages(r.data.pages); setCategories(r.data.categories || []); }).catch(function(){}).finally(function() { setLoading(false); });
  }, [page, cat, search]);

  useEffect(function(){fetch();}, [fetch]);
  // Page title & SEO handled globally by useSEO (utils/seo.js)

  var handleSearch = function(e) { e.preventDefault(); setSp({ search: search, page: "1" }); };
  var goPage = function(p) { var params = { page: String(p) }; if (cat) params.category = cat; if (search) params.search = search; setSp(params); window.scrollTo(0,0); };

  return (
    <MarketingLayout>
      <style>{`
        .art-hero { padding:64px 24px 32px; text-align:center; }
        .art-hero h1 { font-family:'Lora',Georgia,serif; font-size:36px; font-weight:600; margin:0 0 12px; }
        .art-hero p { font-size:17px; color:#6f6f64; max-width:480px; margin:0 auto 24px; }
        .art-search { max-width:420px; margin:0 auto; display:flex; gap:8px; }
        .art-search input { flex:1; height:46px; padding:0 16px 0 42px; border:1.5px solid #E8E2D5; border-radius:50px; background:#fff; font-size:15px; color:#23241E; outline:none; font-family:inherit; box-sizing:border-box; }
        .art-search input:focus { border-color:#7ED957; box-shadow:0 0 0 3px rgba(126,217,87,.15); }
        .art-search .icon { position:absolute; left:16px; top:50%; transform:translateY(-50%); color:#6f6f64; }
        .art-search-wrap { position:relative; flex:1; }
        .art-search button { height:46px; padding:0 20px; border:none; border-radius:50px; background:#14432B; color:#F4EFE4; font-size:14px; font-weight:700; cursor:pointer; font-family:inherit; }
        .art-cats { max-width:1100px; margin:0 auto; padding:16px 24px; display:flex; flex-wrap:wrap; gap:8px; }
        .art-grid { max-width:1100px; margin:0 auto; padding:16px 24px 64px; display:grid; grid-template-columns:repeat(auto-fill,minmax(320px,1fr)); gap:24px; }
        .art-card { background:#fff; border:1.5px solid #E8E2D5; border-radius:16px; overflow:hidden; transition:transform .2s,box-shadow .2s; text-decoration:none; color:inherit; display:block; }
        .art-card:hover { transform:translateY(-4px); box-shadow:0 12px 40px rgba(20,67,43,.08); }
        .art-card-img { height:200px; background:#E8E2D5; overflow:hidden; }
        .art-card-img img { width:100%; height:100%; object-fit:cover; }
        .art-card-img .placeholder { height:100%; display:flex; align-items:center; justify-content:center; background:linear-gradient(135deg,#E8E2D5 0%,#F4EFE4 100%); }
        .art-card-body { padding:20px; }
        .art-card-meta { display:flex; align-items:center; gap:8px; margin-bottom:10px; }
        .art-card h2 { font-family:'Lora',Georgia,serif; font-size:18px; font-weight:600; margin:0 0 8px; line-height:1.35; }
        .art-card p { font-size:14px; color:#6f6f64; line-height:1.5; margin:0; }
        .art-card .read-more { display:flex; align-items:center; gap:4px; margin-top:14px; font-size:14px; font-weight:600; color:#3F7D52; }
        .art-empty { text-align:center; padding:80px 24px; color:#6f6f64; }
        .art-pager { display:flex; align-items:center; justify-content:center; gap:12px; padding:0 24px 64px; }
        .art-pager button { width:40px; height:40px; border:1.5px solid #E8E2D5; border-radius:10px; background:#fff; cursor:pointer; display:flex; align-items:center; justify-content:center; }
        .art-pager button:disabled { opacity:.3; cursor:default; }
      `}</style>

      <div className="art-hero">
        <h1>Money tips that actually help</h1>
        <p>Practical guides on budgeting, bills, saving, and building wealth — written for Canadians.</p>
        <form onSubmit={handleSearch} className="art-search">
          <div className="art-search-wrap"><Search size={18} className="icon" /><input placeholder="Search articles..." value={search} onChange={function(e){setSearch(e.target.value);}} /></div>
          <button type="submit">Search</button>
        </form>
      </div>

      {categories.length > 0 && <div className="art-cats">
        {categories.map(function(c){return <Badge key={c} variant={cat===c?"default":"outline"} className="cursor-pointer text-sm px-4 py-1.5 rounded-full" style={cat===c?{background:"#14432B",color:"#F4EFE4"}:{}} onClick={function(){var n=cat===c?"":c;setCat(n);var p={page:"1"};if(n)p.category=n;if(search)p.search=search;setSp(p);}}>{c}</Badge>;})}
      </div>}

      {loading ? (
        <div className="art-grid">{[1,2,3,4,5,6].map(function(i){return <div key={i} className="art-card"><div className="art-card-img"><div className="placeholder" /></div><div className="art-card-body"><div style={{height:14,background:"#E8E2D5",borderRadius:6,width:"40%",marginBottom:10}} /><div style={{height:20,background:"#E8E2D5",borderRadius:6,marginBottom:8}} /><div style={{height:14,background:"#E8E2D5",borderRadius:6,width:"70%"}} /></div></div>;})}</div>
      ) : articles.length === 0 ? (
        <div className="art-empty"><BookOpen size={48} style={{opacity:.2,marginBottom:16}} /><h2 style={{fontFamily:"'Lora',serif",fontSize:20,marginBottom:8}}>No articles found</h2><p>{search?"Try a different search.":"Check back soon."}</p></div>
      ) : (
        <>
          <div className="art-grid">{articles.map(function(a){return (
            <Link key={a.id} to={"/articles/"+a.slug} className="art-card">
              <div className="art-card-img">{a.featured_image?<img src={a.featured_image.startsWith("http")?a.featured_image:API+a.featured_image} alt={a.title} />:<div className="placeholder"><BookOpen size={32} style={{color:"#6f6f64",opacity:.3}} /></div>}</div>
              <div className="art-card-body">
                <div className="art-card-meta">{a.category&&<Badge variant="outline" style={{fontSize:12,borderRadius:50}}>{a.category}</Badge>}<span style={{fontSize:12,color:"#6f6f64",display:"flex",alignItems:"center",gap:4}}><Clock size={12} />{a.read_time} min</span></div>
                <h2>{a.title}</h2>
                <p>{a.excerpt}</p>
                <div className="read-more">Read article <ArrowRight size={14} /></div>
              </div>
            </Link>);})}</div>
          {pages > 1 && <div className="art-pager"><button disabled={page<=1} onClick={function(){goPage(page-1);}}><ChevronLeft size={18} /></button><span style={{fontSize:14,color:"#6f6f64"}}>Page {page} of {pages}</span><button disabled={page>=pages} onClick={function(){goPage(page+1);}}><ChevronRight size={18} /></button></div>}
        </>
      )}
    </MarketingLayout>
  );
};
export default ArticlesPage;
